import axiosInstance from "../axiosInstance";

export const statsService = {
  order_fill_rate: async (data, signal) => {
    try {
      let response = await axiosInstance.post("/order-fill-rate", data, {
        signal,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  current_order_fill_rate: async (data, signal) => {
    try {
      let response = await axiosInstance.get(
        `/order-fill-rate?${
          data.client_id ? "client_id=" + data.client_id : ""
        }`,
        { signal },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  currentAverageSLA: async (data, signal) => {
    try {
      let response = await axiosInstance.post("/order-cycle-time", data, {
        signal,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  slaComparision: async (data, signal) => {
    try {
      let response = await axiosInstance.post(`/sla-comparision`, data, {
        signal,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchStats: async (obj, signal) => {
    try {
      console.log("🔄 [StatsService] Fetching stats from backend");
      let response = await axiosInstance.post("/stats", obj, { signal });
      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  fetchOrderByRange: async (data, signal) => {
    try {
      console.log("🔄 [StatsService] Fetching order range stats from backend");
      let response = await axiosInstance.post("/order-range-stats", data, {
        signal,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchCurrentWeekStatusCounts: async (data, signal) => {
    try {
      console.log("🔄 [StatsService] Fetching current week stats from backend");
      let response = await axiosInstance.post("/current-week-stats", data, {
        signal,
      });
      return response.data;
    } catch (error) {
      console.error("Error in fetchCurrentWeekStatusCounts:", error);
      throw error;
    }
  },
  fetchOrderStatusByRange: async (data, signal) => {
    try {
      console.log(
        "🔄 [StatsService] Fetching order status by range from backend",
      );
      let response = await axiosInstance.post("/order-status-by-range", data, {
        signal,
      });
      return response.data;
    } catch (error) {
      console.error("Error in fetchOrderStatusByRange:", error);
      throw error;
    }
  },
  fetchOrderSLAByRange: async (data, signal) => {
    try {
      console.log("🔄 [StatsService] Fetching order SLA by range from backend");
      let response = await axiosInstance.post(
        "/sla-comparision-by-range",
        data,
        { signal },
      );
      return response.data;
    } catch (error) {
      console.error("Error in fetchOrderSLAByRange:", error);
      throw error;
    }
  },
  exportAsPDF: async (dashboardData, signal = null) => {
    try {
      // Only attach abort listener if signal is a valid AbortSignal
      if (signal && typeof signal.addEventListener === "function") {
        signal.addEventListener("abort", () => {
          console.log("Export request aborted");
        });
      }
      let response = await axiosInstance.post(
        "/export-dashboard",
        dashboardData,
        signal ? { signal } : {},
      );
      return response.data;
    } catch (error) {
      console.error("Error in exportAsPDF:", error);
      throw error;
    }
  },
};
